module.exports = __webpack_public_path__ + "static/media/bleuMoreOpacityMarker.510130a2.svg";